import React from "react";
import { Phone, Mail, MapPin } from "lucide-react";
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from "react-icons/fa";
const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-8 mt-auto">
      <div className="container mx-auto px-4 grid grid-cols-1 md:grid-cols-2 gap-20 text-center md:text-left relative">
        
        {/* About Section */}
        <div>
          <h3 className="text-xl font-bold text-yellow-400">About Us</h3>
          <p className="text-gray-300 mt-2">
          At Watford Taxi, we specialize in providing prompt and reliable transportation services. Whether you need a ride for a local journey or a smooth airport transfer, we've got you covered. Our fleet includes saloon cars, executive vehicles, and MPVs, ensuring comfort for individuals and groups. We offer competitive pricing, professional drivers, and easy online booking. From Heathrow to Gatwick and everywhere in between, trust us for your transport needs. Book your journey today!
          </p>
          {/* social media icons */}
          <div className="flex pt-5 space-x-6">
      {/* Facebook Icon */}
      <a
        href="https://www.facebook.com"
        target="_blank"
        rel="noopener noreferrer"
        className="p-3 border-2 border-yellow-400 rounded-full text-white hover:bg-yellow-400 hover:text-gray-900 transition duration-300"
      >
        <FaFacebook size={24} />
      </a>

      {/* Twitter Icon */}
      <a
        href="https://www.twitter.com"
        target="_blank"
        rel="noopener noreferrer"
        className="p-3 border-2 border-yellow-400 rounded-full text-white hover:bg-yellow-400 hover:text-gray-900 transition duration-300"
      >
        <FaTwitter size={24} />
      </a>

      {/* Instagram Icon */}
      <a
        href="https://www.instagram.com"
        target="_blank"
        rel="noopener noreferrer"
        className="p-3 border-2 border-yellow-400 rounded-full text-white hover:bg-yellow-400 hover:text-gray-900 transition duration-300"
      >
        <FaInstagram size={24} />
      </a>

      {/* LinkedIn Icon */}
      <a
        href="https://www.linkedin.com"
        target="_blank"
        rel="noopener noreferrer"
        className="p-3 border-2 border-yellow-400 rounded-full text-white hover:bg-yellow-400 hover:text-gray-900 transition duration-300"
      >
        <FaLinkedin size={24} />
      </a>
    </div>
        </div>

        {/* Contact Section */}
<div>
  <h3 className="text-xl font-bold text-yellow-400">Contact Us</h3>
  <div className="flex items-center gap-2 mt-2 mb-3">
    <Phone className="text-yellow-400 group-hover:text-white transition duration-300" />
    <p className="text-gray-300 group-hover:text-white transition duration-300">01923 803 603</p>
  </div>
  <div className="flex items-center gap-2 mb-3">
    <Mail className="text-yellow-400 group-hover:text-white transition duration-300" />
    <p className="text-gray-300 group-hover:text-white transition duration-300">info@watfordtaxi.com</p>
  </div>
  <div className="flex items-center gap-2 mb-3">
    <MapPin className="text-yellow-400 group-hover:text-white transition duration-300" />
    <p className="text-gray-300 group-hover:text-white transition duration-300">Watford, United Kingdom</p>
  </div>
</div>


        {/* Car Image Section */}
        <div className="hidden md:block absolute right-0 bottom-0 w-1/4 animate-bounce-up-down">
          <img
            src="/saloon.png" // Replace with your car image path
            alt="Car"
            className="w-full h-auto"
          />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
